import { I } from "@/components/kamibot-v2/discord";

type CostItem = {
  ic: "voice" | "ai" | "music" | "server";
  label: string;
  unit: string;
  cost: string;
  detail: string;
};

const COST_ITEMS: CostItem[] = [
  {
    ic: "voice",
    label: "음성 합성 (TTS)",
    unit: "1분당",
    cost: "약 ₩30 ~ ₩90",
    detail:
      "고품질 모델은 일반 모델보다 3배 더 비싸요. 자주 길게 쓰면 무료 한도 안에서 막아두는 게 카미봇이 살 길이에요…",
  },
  {
    ic: "ai",
    label: "AI 어시스턴트",
    unit: "메시지당",
    cost: "약 ₩5 ~ ₩40",
    detail:
      "긴 컨텍스트 + 답변일수록 비용이 올라가요. 프로는 모델 등급도 한 단계 올라가요.",
  },
  {
    ic: "music",
    label: "음악 스트리밍",
    unit: "시간당",
    cost: "약 ₩15 (대역폭)",
    detail:
      "고품질 음원은 일반 음원보다 데이터가 4배예요. 음악 봇이 공짜인 시대는 사실 이상해요…",
  },
  {
    ic: "server",
    label: "서버 인프라",
    unit: "월",
    cost: "약 ₩200,000",
    detail:
      "디스코드 봇은 24/7 켜져 있어야 해서, 서버를 끌 수 없어요. 사용량과 무관하게 매달 나가는 비용이에요.",
  },
];

const ICON_MAP = {
  voice: I.mic,
  ai: I.sparkle,
  music: I.music,
  server: I.database,
} as const;

export function PremiumCosts() {
  return (
    <section className="prem-costs" id="costs">
      <div className="shell">
        <div className="section-head">
          <span className="section-eyebrow">
            <I.eye /> HONEST · 솔직히
          </span>
          <h2 className="section-title">
            &ldquo;왜 이게 프리미엄이에요?&rdquo; — 정직한 답.
          </h2>
          <p className="section-sub">
            기능을 일부러 잠가둔 게 아니에요. 진짜로 비싼 자원을 쓰는 기능들이라,
            <br />
            무료로 무제한 풀면 카미봇이 한 달도 못 버텨요. 숫자로 보여드릴게요.
          </p>
        </div>

        <div className="prem-cost-table">
          {COST_ITEMS.map((c, i) => {
            const Ic = ICON_MAP[c.ic];
            return (
              <div key={i} className="prem-cost-row">
                <div className="prem-cost-ic">
                  <Ic />
                </div>
                <div className="prem-cost-meta">
                  <div className="prem-cost-head">
                    <span className="prem-cost-label">{c.label}</span>
                    <span className="prem-cost-unit">{c.unit}</span>
                  </div>
                  <p className="prem-cost-detail">{c.detail}</p>
                </div>
                <div className="prem-cost-num">
                  <code>{c.cost}</code>
                </div>
              </div>
            );
          })}
        </div>

        <div className="prem-cost-callout gowun">
          <div className="prem-cost-callout-mark">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/kamibot-character/kamibot-portrait.png" alt="" />
          </div>
          <div>
            <p>
              <b>무료 사용자분께</b> — 위 비용들은 카미봇이 부담하고 있어요.
              그래서 무료 한도가 살짝 빡빡할 수 있어요. 미리 양해 부탁드려요.
            </p>
            <p className="shy">
              멤버십에 가입해주시는 분들이 계셔서, 무료 분들이 그만큼 더 풍요롭게 쓸 수 있어요. 정말로요.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
